import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  sectionTitle: {
    fontWeight: 600,
  },
  addRow: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'flex-start',
    padding: theme.spacing(2),
  },
  emptyMessage: {
    padding: theme.spacing(1, 0),
  },
  skeletonList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  emphasisColor: {
    backgroundColor: theme.palette.background.default,
  },
}))

export default useStyles
